export default "__VITE_ASSET__45fec5ca__"